import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Spinner, Button } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';

const ProductDetails = () => {
    const { imageName } = useParams();
    const navigate = useNavigate();
    const [details, setDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchDetails = async () => {
            try {
                const response = await fetch(`/api/get_image_details?image_name=${encodeURIComponent(imageName)}`);
                if (!response.ok) throw new Error('Failed to fetch image details');
                const data = await response.json();
                setDetails(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        fetchDetails();
    }, [imageName]);

    return (
        <Container className="py-4">
            {loading ? (
                <div className="d-flex justify-content-center align-items-center py-5">
                    <Spinner animation="border" variant="dark" />
                </div>
            ) : error ? (
                <div className="text-center text-danger py-5">
                    <p className="mb-0 fw-semibold">{error}</p>
                </div>
            ) : (
                <Row className="g-4 align-items-start">
                    {/* Product Image */}
                    <Col lg={5}>
                             <div className="w-100 rounded-4 d-flex flex-column align-items-center justify-content-center" style={{ height: "500px" }}>
                    <img
                        src={(details?.image_path && (details.image_path.startsWith('http://') || details.image_path.startsWith('https://'))) 
                            ? details.image_path : `/api/Images/${details.image_name}`}
                        alt={imageName}
                        className="img-fluid"
                        style={{
                            maxHeight: "100%",
                            maxWidth: "100%",
                            objectFit: "contain",
                            borderRadius: "0.5rem",
                        }}/>
                    <p className="fw-bold fs-5 text-capitalize my-3">{details?.image_name}</p>
                </div>
                            
                    </Col>

                    {/* Product Details */}
                    <Col lg={7}>
                        <div className="px-4">
                            {/* Description */}
                            <div className="mb-4">
                                <h6 className="text-start fw-bold mb-3 px-4 d-flex align-items-center">
                                    About
                                    {details?.model && (
                                        <span className="badge bg-secondary ms-2" style={{ fontSize: '0.65em' }}>
                                           {details.model.charAt(0).toUpperCase() + details.model.slice(1)}
                                        </span>
                                    )}
                                </h6>
                                <hr className='ms-4 border-2'/>
                                <div className="text-start px-4 text-muted mb-0 lh-lg">
                                    {details?.description || 'No description available.'}
                                </div>
                            </div>
                            {/* Tags */}
                            {(() => {
                                let parsedTags = details?.tags;
                                if (typeof parsedTags === 'string') {
                                    try {
                                        parsedTags = JSON.parse(parsedTags);
                                    } catch (e) {}
                                }
                                if (!parsedTags || Object.keys(parsedTags).length === 0) return null;

                                return (
                                    <div>
                                        <h6 className="text-start fw-bold mb-3 px-4">
                                            Tags
                                        </h6>
                                        <hr className='ms-4 border-2'/>

                                        <div className="d-flex flex-column gap-1">
                                            {Object.entries(parsedTags).map(([key, val]) => {
                                                let formattedVal = val;

                                                if (Array.isArray(val)) {
                                                    formattedVal = val
                                                        .filter(v => v && v.toLowerCase() !== 'unknown')
                                                        .join(', ');
                                                } else if (
                                                    typeof val === 'string' &&
                                                    val.toLowerCase() === 'unknown'
                                                ) {
                                                    formattedVal = '';
                                                }

                                                if (!formattedVal) return null;

                                                return (
                                                    <div
                                                        key={key}
                                                        className="d-flex text-start pb-2 ps-4">
                                                        <div
                                                            className="fw-semibold text-dark text-capitalize me-2"
                                                            style={{ minWidth: "170px" }}>
                                                            {key.replace(/_/g, ' ')}
                                                        </div>

                                                        <div className="text-muted text-capitalize">
                                                            {formattedVal}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                );
                            })()}
                        </div>
                    </Col>
                </Row>
            )}
        </Container>
    );
};

export default ProductDetails;
